import { render, staticRenderFns } from "./ModalPracticeArea.vue?vue&type=template&id=4ef98fec&scoped=true"
import script from "./ModalPracticeArea.vue?vue&type=script&lang=js"
export * from "./ModalPracticeArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef98fec",
  null
  
)

export default component.exports